import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '../user/user.service';
import { map, take, filter } from 'rxjs/operators';

export const storeSelectedGuard: CanActivateFn = (route, state) => {
   const userService = inject(UserService);
   const router = inject(Router);

   // Skip guard for store route itself
   if (route.routeConfig?.path === 'store') {
      return true;
   }

   // Skip guard for admin routes - admins don't need a store
   if (state.url.startsWith('/admin')) {
      return true;
   }

   // Check if admin is impersonating a store
   const impersonatedStore = localStorage.getItem('admin_impersonated_store');
   if (impersonatedStore) {
      // Admin is impersonating - load the impersonated store
      userService.setCurrentStore(impersonatedStore);
      return true;
   }

   return userService.currentUser$.pipe(
      filter((user) => user !== null), // Wait for auth to complete (skip initial null)
      take(1),
      map((user) => {
         if (!user.storeId) {
            // User logged in but no store selected - redirect to store page
            router.navigate(['/store']);
            return false;
         }

         return true;
      }),
   );
};
